import { IRegistrationFormState } from "src/reducers/reactReduxForms";
import * as Dtos from "../dtos/Tmd.dtos";

export class CollectionInstanceDataState {
    public id: number;
    public isDisabled: boolean;
    public isAnswered: boolean;
    public isRequired: boolean;
    public isValid: boolean;
    public validations: Dtos.ResponseError[];
}

export const filterCollectionItemComponentsByColumn = (
    collection: Dtos.Collection,
    column: number
): Dtos.CollectionItemComponent[] => {
    if (collection && collection.collectionItemComponents) {
        return collection.collectionItemComponents
            .filter((p) =>
                p.active == true &&
                p.column == column &&
                p.itemComponent.active &&
                (p.itemComponent.customInputControlName != "" ||
                    p.itemComponent.itemComponentPrimitives.filter((f) =>
                        f.active && f.itemPrimitive != Dtos.ItemPrimitive.Documents
                    ).length > 0)
            )
            .sort((a, b) => a.rank - b.rank);
    }

    return [];
};

export const filterCollectionItemComponentsByDocuments = (
    collection: Dtos.Collection
): Dtos.CollectionItemComponent[] => {
    if (collection && collection.collectionItemComponents) {
        return collection.collectionItemComponents
            .filter((p) =>
                p.active == true &&
                p.itemComponent.active &&
                p.itemComponent.itemComponentPrimitives.filter((f) => 
                    f.active && f.itemPrimitive == Dtos.ItemPrimitive.Documents
                ).length > 0
            )
            .sort((a, b) => a.rank - b.rank);
    }

    return [];
};

export const findCompareItemComponentWithData = (
    itemComponentWithData: Dtos.ItemComponentWithData,
    itemComponentWithDatas: Dtos.ItemComponentWithData[],
    compareItemComponentPrimitiveId: number
): Dtos.ItemComponentWithData | undefined => {
    // find the primitive on the same collection instance and item component
    const collectionInstanceId = itemComponentWithData.collectionInstanceData.collectionInstanceId;
    const itemComponentId = itemComponentWithData.collectionInstanceData.itemComponentId;

    let foundItemComponentWithData = itemComponentWithDatas.find((f) =>
        f.collectionInstanceData.collectionInstanceId == collectionInstanceId &&
        f.collectionInstanceData.itemComponentId == itemComponentId &&
        f.collectionInstanceData.itemComponentPrimitiveId == compareItemComponentPrimitiveId
    );

    return foundItemComponentWithData;
};

export const validateCollectionInstance = (
    itemComponentWithDatas: Dtos.ItemComponentWithData[],
    disabled: boolean
): CollectionInstanceDataState[] => {
    let collectionInstanceDataStates: CollectionInstanceDataState[] = [];

    itemComponentWithDatas.forEach((itemComponentWithData) => {
        let collectionInstanceDataState: CollectionInstanceDataState = {
            id: itemComponentWithData.collectionInstanceData.id,
            isAnswered: false,
            isDisabled: disabled || itemComponentWithData.formLocked, // readonly || savingCollectionInstance || locked;
            isRequired: false,
            isValid: true,
            validations: [],
        };

        if (itemComponentWithData.itemComponentRules && itemComponentWithData.itemComponentRules.length > 0) {
            itemComponentWithData.itemComponentRules.forEach((rule) => {
                if (rule.itemPrimitiveRule ==  Dtos.ItemPrimitiveRule.IsDisabledIf) {
                    const compareItemComponentWithData: Dtos.ItemComponentWithData = 
                        findCompareItemComponentWithData(
                            itemComponentWithData,
                            itemComponentWithDatas,
                            rule.compareItemComponentPrimitiveId
                        );
                    if (compareItemComponentWithData != undefined) {
                        if (compareItemComponentWithData.itemComponentPrimitive != undefined) {
                            switch (compareItemComponentWithData.itemComponentPrimitive.itemPrimitive) {
                                case Dtos.ItemPrimitive.Checkbox:
                                    if (compareItemComponentWithData.collectionInstanceData.bitValue == true &&
                                        (rule.compareValue == "1" ||rule.compareValue.toLowerCase() =="true")
                                    ) {
                                        collectionInstanceDataState.isDisabled = true;
                                    }
                                    if (compareItemComponentWithData.collectionInstanceData.bitValue == false &&
                                        (rule.compareValue == "" || rule.compareValue == "0" || rule.compareValue.toLowerCase() == "false")
                                    ) {
                                        collectionInstanceDataState.isDisabled = true;
                                    }
                                    break;
                                case Dtos.ItemPrimitive.Text:
                                    if (compareItemComponentWithData.collectionInstanceData.textValue.toLowerCase() == rule.compareValue.toLowerCase()) {
                                        collectionInstanceDataState.isDisabled = true;
                                    }
                                    break;
                                case Dtos.ItemPrimitive.Comments:
                                    if (compareItemComponentWithData.collectionInstanceData.textValue.toLowerCase() == rule.compareValue.toLowerCase()) {
                                        collectionInstanceDataState.isDisabled = true;
                                    }
                                    break;
                                case Dtos.ItemPrimitive.Select:
                                    let option = compareItemComponentWithData.itemComponentPrimitive.itemComponentPrimitiveOptions.find((f) =>
                                        f.active &&
                                        f.value != undefined &&
                                        f.value != null &&
                                        f.value.toLowerCase() == rule.compareValue.toLowerCase()
                                    );
                                    if (option && option.id == compareItemComponentWithData.collectionInstanceData.intValue) {
                                        collectionInstanceDataState.isDisabled = true;
                                    }
                                    break;
                                case Dtos.ItemPrimitive.Numeric:
                                    if (compareItemComponentWithData.collectionInstanceData.numberValue.toString() == rule.compareValue) {
                                        collectionInstanceDataState.isDisabled = true;
                                    }
                                    break;
                            }
                        }
                    }
                }
                if (rule.itemPrimitiveRule == Dtos.ItemPrimitiveRule.IsEnabledIf) {
                    const compareItemComponentWithData: Dtos.ItemComponentWithData = 
                        findCompareItemComponentWithData(
                            itemComponentWithData,
                            itemComponentWithDatas,
                            rule.compareItemComponentPrimitiveId
                        );
                    if (compareItemComponentWithData != undefined) {
                        if (compareItemComponentWithData.itemComponentPrimitive != undefined) {
                            collectionInstanceDataState.isDisabled = true;
                            switch (compareItemComponentWithData.itemComponentPrimitive.itemPrimitive) {
                                case Dtos.ItemPrimitive.Checkbox:
                                    if (compareItemComponentWithData.collectionInstanceData.bitValue == true &&
                                        (rule.compareValue == "1" || rule.compareValue.toLowerCase() == "true")
                                    ) {
                                        collectionInstanceDataState.isDisabled = false;
                                    }
                                    if (compareItemComponentWithData.collectionInstanceData.bitValue == false &&
                                        (rule.compareValue == "" || rule.compareValue == "0" || rule.compareValue.toLowerCase() == "false")
                                    ) {
                                        collectionInstanceDataState.isDisabled = false;
                                    }
                                    break;
                                case Dtos.ItemPrimitive.Text:
                                    if (compareItemComponentWithData.collectionInstanceData.textValue.toLowerCase() == rule.compareValue.toLowerCase()) {
                                        collectionInstanceDataState.isDisabled = false;
                                    }
                                    break;
                                case Dtos.ItemPrimitive.Comments:
                                    if (compareItemComponentWithData.collectionInstanceData.textValue.toLowerCase() == rule.compareValue.toLowerCase()
                                    ) {
                                        collectionInstanceDataState.isDisabled = false;
                                    }
                                    break;
                                case Dtos.ItemPrimitive.Select:
                                    let option = compareItemComponentWithData.itemComponentPrimitive.itemComponentPrimitiveOptions.find((f) =>
                                        f.value.toLowerCase() == rule.compareValue.toLowerCase()
                                    );
                                    if (option && option.id == compareItemComponentWithData.collectionInstanceData.intValue) {
                                        collectionInstanceDataState.isDisabled = false;
                                    }
                                    break;
                                case Dtos.ItemPrimitive.Numeric:
                                    if (compareItemComponentWithData.collectionInstanceData.numberValue.toString() == rule.compareValue) {
                                        collectionInstanceDataState.isDisabled = false;
                                    }
                                    break;
                            }
                        }
                    }
                }
                if (rule.itemPrimitiveRule == Dtos.ItemPrimitiveRule.Required) {
                    collectionInstanceDataState.isRequired = true;
                }
                if (rule.itemPrimitiveRule == Dtos.ItemPrimitiveRule.RequiredIf) {
                    const compareItemComponentWithData: Dtos.ItemComponentWithData = 
                        findCompareItemComponentWithData(
                            itemComponentWithData,
                            itemComponentWithDatas,
                            rule.compareItemComponentPrimitiveId
                        );
                    if (compareItemComponentWithData != undefined) {
                        if (compareItemComponentWithData.itemComponentPrimitive != undefined) {
                            switch (compareItemComponentWithData.itemComponentPrimitive.itemPrimitive) {
                                case Dtos.ItemPrimitive.Checkbox:
                                    if (compareItemComponentWithData.collectionInstanceData.bitValue == true &&
                                        (rule.compareValue == "1" || rule.compareValue.toLowerCase() == "true")
                                    ) {
                                        collectionInstanceDataState.isRequired = true;
                                    }
                                    if (compareItemComponentWithData .collectionInstanceData.bitValue == false &&
                                        (rule.compareValue == "" || rule.compareValue == "0" || rule.compareValue.toLowerCase() == "false")
                                    ) {
                                        collectionInstanceDataState.isRequired = true;
                                    }
                                    break;
                                case Dtos.ItemPrimitive.Text:
                                    if (compareItemComponentWithData.collectionInstanceData.textValue.toLowerCase() == rule.compareValue.toLowerCase()) {
                                        collectionInstanceDataState.isRequired = true;
                                    }
                                    break;
                                case Dtos.ItemPrimitive.Comments:
                                    if (compareItemComponentWithData.collectionInstanceData.textValue.toLowerCase() == rule.compareValue.toLowerCase()) {
                                        collectionInstanceDataState.isRequired = true;
                                    }
                                    break;
                                case Dtos.ItemPrimitive.Select:
                                    let option = compareItemComponentWithData.itemComponentPrimitive.itemComponentPrimitiveOptions.find((f) =>
                                        f.value.toLowerCase() == rule.compareValue.toLowerCase()
                                    );
                                    if (option && option.id == compareItemComponentWithData.collectionInstanceData.intValue) {
                                        collectionInstanceDataState.isRequired = true;
                                    }
                                    break;
                                case Dtos.ItemPrimitive.Numeric:
                                    if (compareItemComponentWithData.collectionInstanceData.numberValue.toString() == rule.compareValue) {
                                        collectionInstanceDataState.isRequired = true;
                                    }
                                    break;
                            }
                        }
                    }
                }
            });
            if (collectionInstanceDataState.isRequired && collectionInstanceDataState.isDisabled) {
                collectionInstanceDataState.isRequired = false;
            }
            if (collectionInstanceDataState.isRequired) {
                // check for a value being entered
                if (
                    itemComponentWithData.isQuestion &&
                    itemComponentWithData.itemComponentPrimitive != undefined &&
                    itemComponentWithData.collectionInstanceData != undefined
                ) {
                    switch (itemComponentWithData.itemComponentPrimitive.itemPrimitive) {
                        case Dtos.ItemPrimitive.Select:
                            if (
                                itemComponentWithData.collectionInstanceData.intValue != undefined &&
                                itemComponentWithData.collectionInstanceData.intValue != null &&
                                itemComponentWithData.collectionInstanceData.intValue > 0
                            ) {
                                collectionInstanceDataState.isAnswered = true;
                            }
                            break;
                        case Dtos.ItemPrimitive.Comments:
                            if (
                                itemComponentWithData.collectionInstanceData.textValue != undefined &&
                                itemComponentWithData.collectionInstanceData.textValue != null &&
                                itemComponentWithData.collectionInstanceData.textValue.length > 0
                            ) {
                                collectionInstanceDataState.isAnswered = true;
                            }
                            break;
                        case Dtos.ItemPrimitive.Date:
                            if (
                                itemComponentWithData.collectionInstanceData.dateValue != undefined &&
                                itemComponentWithData.collectionInstanceData.dateValue != null
                            ) {
                                collectionInstanceDataState.isAnswered = true;
                            }
                            break;
                        case Dtos.ItemPrimitive.Text:
                            if (
                                itemComponentWithData.collectionInstanceData.textValue != undefined &&
                                itemComponentWithData.collectionInstanceData.textValue != null &&
                                itemComponentWithData.collectionInstanceData.textValue.length > 0
                            ) {
                                collectionInstanceDataState.isAnswered = true;
                            }
                            break;
                        case Dtos.ItemPrimitive.Numeric:
                            if (
                                (itemComponentWithData.collectionInstanceData.intValue != undefined &&
                                    itemComponentWithData.collectionInstanceData.intValue != null &&
                                    itemComponentWithData.collectionInstanceData.intValue !== 0) ||
                                (itemComponentWithData.collectionInstanceData.numberValue != undefined &&
                                    itemComponentWithData.collectionInstanceData.numberValue != null &&
                                    itemComponentWithData.collectionInstanceData.numberValue !== 0)
                            ) {
                                collectionInstanceDataState.isAnswered = true;
                            }
                            break;
                    }
                }

                if (itemComponentWithData.isQuestion && !collectionInstanceDataState.isAnswered) {
                    const fieldName = `CollectionInstanceDatas[${itemComponentWithData.collectionInstanceData.id.toString()}].TextValue`;
                    if (collectionInstanceDataState.validations.filter((f) => f.fieldName == fieldName).length === 0) {
                        let validationFailure: Dtos.ResponseError = new Dtos.ResponseError();
                        validationFailure.errorCode = "CID-001";
                        validationFailure.fieldName = `CollectionInstanceDatas[${itemComponentWithData.collectionInstanceData.id.toString()}].TextValue`;
                        validationFailure.message = "This field is required";
                        collectionInstanceDataState.validations.push(validationFailure);
                    }
                }
            }
        }

        collectionInstanceDataStates.push(collectionInstanceDataState);
    });

    return collectionInstanceDataStates;
};

export const collectionInstanceIsValid = (
    collectionInstanceDataState: CollectionInstanceDataState[]
): boolean => {
    let isValid: boolean = true;
    if (collectionInstanceDataState) {
        isValid = collectionInstanceDataState.filter((f) => f.validations.length > 0).length == 0;
    }
    return isValid;
};

export const flattenItemComponentWithDatas = (
    form: Dtos.CollectionInstance & IRegistrationFormState
): Dtos.ItemComponentWithData[] => {
    /* combine the datas into an array */
    let itemComponentWithDatas: Dtos.ItemComponentWithData[] = [];

    form.column1.forEach((itemComponentWithData) => {
        itemComponentWithDatas.push(itemComponentWithData);
    });
    form.column2.forEach((itemComponentWithData) => {
        itemComponentWithDatas.push(itemComponentWithData);
    });
    form.column3.forEach((itemComponentWithData) => {
        itemComponentWithDatas.push(itemComponentWithData);
    });

    return itemComponentWithDatas;
};